module.exports = __webpack_public_path__ + "static/media/splashnode-logo.edd8352c.svg";